import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { Reframe } from './components/Reframe';
import { TraditionalMethods } from './components/TraditionalMethods';
import { Mechanism } from './components/Mechanism';
import { ProductPresentation } from './components/ProductPresentation';
import { Testimonials } from './components/Testimonials';
import { Benefits } from './components/Benefits';
import { ValueStack } from './components/ValueStack';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-brand-bg font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Identification data-id="element-4" />
        <Reframe data-id="element-5" />
        <TraditionalMethods data-id="element-6" />
        <Mechanism data-id="element-7" />
        <ProductPresentation data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Benefits data-id="element-10" />
        <ValueStack data-id="element-11" />
        <FinalCTA data-id="element-12" />
        <FAQ data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}